module.exports = __webpack_public_path__ + "img/template3.3ba8c3ac.svg";